<mat-card class="proyecto-content">
    <h3>{{ (data | async)?.Titulo }}</h3>
    <div class="proyecto-item-content">
        <div class="proyecto-item" *ngFor="let item of (data | async).Imagenes">
            <img [src]="imagen.Imagen" [alt]="imagen.Titulo" *ngFor="let imagen of item"
                    class="image">
        </div>
    </div>
</mat-card>